import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const AdditionalInfo = ({ formData, handleChange, errors }) => {
  return (
    <>
      <FormGroup>
        <Label for="tanggalPendataan">57. Tanggal Pendataan</Label>
        <Input 
          type="date" 
          name="tanggalPendataan" 
          id="tanggalPendataan" 
          value={formData.tanggalPendataan} 
          onChange={handleChange}  
        />
        {errors.tanggalPendataan && <div className="invalid-feedback">{errors.tanggalPendataan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="namaSurveyor">58. Nama Surveyor</Label>
        <Input 
          type="text" 
          name="namaSurveyor" 
          id="namaSurveyor" 
          value={formData.namaSurveyor} 
          readOnly 
        />
        {errors.namaSurveyor && <div className="invalid-feedback">{errors.namaSurveyor}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="catatan">59. Catatan</Label>
        <Input 
          type="text" 
          name="catatan" 
          id="catatan" 
          value={formData.catatan} 
          onChange={handleChange}  
        />
        {errors.catatan && <div className="invalid-feedback">{errors.catatan}</div>}
      </FormGroup>
    </>
  );
};

export default AdditionalInfo;
